import { render, staticRenderFns } from "./epb-accordion.component.vue?vue&type=template&id=202600b8&scoped=true"
import script from "./epb-accordion.component.vue?vue&type=script&lang=ts"
export * from "./epb-accordion.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-accordion.component.vue?vue&type=style&index=0&id=202600b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202600b8",
  null
  
)

export default component.exports